import { memo } from "react";
import Chip from "@mui/material/Chip";

import type { BatchTaskSendStatus } from "../helpers/formatBatchTaskDisplay";

export interface BatchTaskSendStatusChipProps {
  status: BatchTaskSendStatus;
  size?: "small" | "medium";
}

const BatchTaskSendStatusChip = memo(
  ({ status, size = "medium" }: BatchTaskSendStatusChipProps) => (
    <Chip
      size={size}
      label={status.label}
      color={status.chipColor}
      sx={{
        fontWeight: 600,
        "& .MuiChip-label": {
          px: 1.75,
          py: 0.5,
        },
      }}
    />
  ),
);

BatchTaskSendStatusChip.displayName = "BatchTaskSendStatusChip";

export default BatchTaskSendStatusChip;
